module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-45.40f3074c.png";